
export const COLORS = {
  PRIMARY: '#1575DB',
  PRIMARY_LIGHT: '#9ac0ea',
  PRIMARY_DARK: '#08223d',
  SECONDARY: '#3a4878',
  SECONDARY_DARK: 'rgba(25, 34, 63, 1)',
  SECONDARY_LIGHT: '#4a6475',
  
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY_50: '#f9fafb',
  GRAY_100: '#f3f4f6',
  GRAY_200: '#e5e7eb',
  GRAY_300: '#d1d5db',
  GRAY_400: '#9ca3af',
  GRAY_500: '#6b7280',
  GRAY_600: '#4b5563',
  GRAY_700: '#374151',
  GRAY_800: '#1f2937',
  GRAY_900: '#111827',
  SUCCESS: '#10b981',
  SUCCESS_DARK: '#059669',
  SUCCESS_LIGHT: '#dcfce7',
  SUCCESS_TEXT: '#166534',
  WARNING: '#f59e0b',
  WARNING_DARK: '#ea580c',
  WARNING_LIGHT: '#fef3c7',
  ERROR: '#ef4444',
  ERROR_LIGHT: '#fee2e2',
  INFO: '#3b82f6',
  INFO_LIGHT: '#dbeafe',
  INFO_TEXT: '#1d4ed8',
  PURPLE: '#7c3aed',
  ORANGE: '#f97316',
  GREEN_LIGHT: '#bbf7d0',
  GREEN_LIGHTER: '#f0fdf4',
};

export const CONSTANT_COLORS = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY_50: '#f9fafb',
  GRAY_100: '#f3f4f6',
  GRAY_200: '#e5e7eb',
  GRAY_300: '#d1d5db',
  GRAY_400: '#9ca3af',
  GRAY_500: '#6b7280',
  GRAY_600: '#4b5563',
  GRAY_700: '#374151',
  GRAY_800: '#1f2937',
  GRAY_900: '#111827',
  SUCCESS: '#10b981',
  SUCCESS_DARK: '#059669',
  SUCCESS_LIGHT: '#dcfce7',
  SUCCESS_TEXT: '#166534',
  WARNING: '#f59e0b',
  WARNING_DARK: '#ea580c',
  WARNING_LIGHT: '#fef3c7',
  ERROR: '#ef4444',
  ERROR_LIGHT: '#fee2e2',
  INFO: '#3b82f6',
  INFO_LIGHT: '#dbeafe',
  INFO_TEXT: '#1d4ed8',
  PURPLE: '#7c3aed',
  ORANGE: '#f97316',
  GREEN_LIGHT: '#bbf7d0',
  GREEN_LIGHTER: '#f0fdf4',
};

export const THEME_COLORS = {
  PRIMARY: '#1575DB',
  PRIMARY_LIGHT: '#9ac0ea',
  PRIMARY_DARK: '#08223d',
  SECONDARY: '#3a4878',
  SECONDARY_DARK: 'rgba(25, 34, 63, 1)',
  SECONDARY_LIGHT: '#4a6475',
};

export default COLORS;